import { render } from "./LuxuryTravel04.vue?vue&type=template&id=d1ca335e&scoped=true"
import script from "./LuxuryTravel04.vue?vue&type=script&lang=js"
export * from "./LuxuryTravel04.vue?vue&type=script&lang=js"

import "./LuxuryTravel04.scss?vue&type=style&index=0&id=d1ca335e&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1ca335e"]])

export default __exports__